/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { InsightsOverTimeBinDtoModel, InsightsOverTimeBinDtoModelType } from "./InsightsOverTimeBinDtoModel"
import { InsightsOverTimeBinDtoModelSelector } from "./InsightsOverTimeBinDtoModel.base"
import { RootStoreType } from "./index"


/**
 * InsightsDriverBreakdownOvertimeDtoBase
 * auto generated base class for the model InsightsDriverBreakdownOvertimeDtoModel.
 */
export const InsightsDriverBreakdownOvertimeDtoModelBase = ModelBase
  .named('InsightsDriverBreakdownOvertimeDto')
  .props({
    __typename: types.optional(types.literal("InsightsDriverBreakdownOvertimeDto"), "InsightsDriverBreakdownOvertimeDto"),
    startDate: types.union(types.undefined, types.null, types.string),
    endDate: types.union(types.undefined, types.null, types.string),
    projectId: types.union(types.undefined, types.null, types.integer),
    driverId: types.union(types.undefined, types.integer),
    completedWorkingTime: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsOverTimeBinDtoModel))),
    estimatedDistanceCompleted: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsOverTimeBinDtoModel))),
    completedRoutes: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsOverTimeBinDtoModel))),
    completedOrders: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsOverTimeBinDtoModel))),
    deliveredOrders: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsOverTimeBinDtoModel))),
    missedOrders: types.union(types.undefined, types.null, types.array(types.late((): any => InsightsOverTimeBinDtoModel))),
    driverName: types.union(types.undefined, types.string),
    deleted: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class InsightsDriverBreakdownOvertimeDtoModelSelector extends QueryBuilder {
  get startDate() { return this.__attr(`startDate`) }
  get endDate() { return this.__attr(`endDate`) }
  get projectId() { return this.__attr(`projectId`) }
  get driverId() { return this.__attr(`driverId`) }
  get driverName() { return this.__attr(`driverName`) }
  get deleted() { return this.__attr(`deleted`) }
  completedWorkingTime(builder: string | InsightsOverTimeBinDtoModelSelector | ((selector: InsightsOverTimeBinDtoModelSelector) => InsightsOverTimeBinDtoModelSelector) | undefined) { return this.__child(`completedWorkingTime`, InsightsOverTimeBinDtoModelSelector, builder) }
  estimatedDistanceCompleted(builder: string | InsightsOverTimeBinDtoModelSelector | ((selector: InsightsOverTimeBinDtoModelSelector) => InsightsOverTimeBinDtoModelSelector) | undefined) { return this.__child(`estimatedDistanceCompleted`, InsightsOverTimeBinDtoModelSelector, builder) }
  completedRoutes(builder: string | InsightsOverTimeBinDtoModelSelector | ((selector: InsightsOverTimeBinDtoModelSelector) => InsightsOverTimeBinDtoModelSelector) | undefined) { return this.__child(`completedRoutes`, InsightsOverTimeBinDtoModelSelector, builder) }
  completedOrders(builder: string | InsightsOverTimeBinDtoModelSelector | ((selector: InsightsOverTimeBinDtoModelSelector) => InsightsOverTimeBinDtoModelSelector) | undefined) { return this.__child(`completedOrders`, InsightsOverTimeBinDtoModelSelector, builder) }
  deliveredOrders(builder: string | InsightsOverTimeBinDtoModelSelector | ((selector: InsightsOverTimeBinDtoModelSelector) => InsightsOverTimeBinDtoModelSelector) | undefined) { return this.__child(`deliveredOrders`, InsightsOverTimeBinDtoModelSelector, builder) }
  missedOrders(builder: string | InsightsOverTimeBinDtoModelSelector | ((selector: InsightsOverTimeBinDtoModelSelector) => InsightsOverTimeBinDtoModelSelector) | undefined) { return this.__child(`missedOrders`, InsightsOverTimeBinDtoModelSelector, builder) }
}
export function selectFromInsightsDriverBreakdownOvertimeDto() {
  return new InsightsDriverBreakdownOvertimeDtoModelSelector()
}

export const insightsDriverBreakdownOvertimeDtoModelPrimitives = selectFromInsightsDriverBreakdownOvertimeDto().startDate.endDate.projectId.driverId.driverName.deleted
